import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { IoTicket } from "react-icons/io5";
import EventDetails from "../components/eventDetails";

const CircularFlag = ({ countryCode }) => {
  const url = `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
  return (
    <div className="w-6 h-6 rounded-full border-2 border-gray-600 p-0.5 bg-black flex items-center justify-center">
      <img
        src={url}
        alt={`${countryCode} Flag`}
        className="object-cover w-full h-full rounded-full"
      />
    </div>
  );
};

// function formatDateTime(dateStr, timeStr) {
//   const dateTime = new Date(`${dateStr}T${timeStr}`);
//   const options = {
//     weekday: "short",
//     month: "short",
//     day: "numeric",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//   };
//   return new Intl.DateTimeFormat("en-US", options).format(dateTime);
// }

function formatDateTime(dateStr, timeStr) {
  const dateTime = new Date(`${dateStr}T${timeStr}`);

  const weekday = dateTime.toLocaleString("en-US", { weekday: "short" });
  const month = dateTime.toLocaleString("en-US", { month: "short" });
  const day = dateTime.getDate();
  const time = dateTime.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${weekday}, ${month} ${day}, ${time}`;
}

export default function Event() {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [showDetails, setShowDetails] = useState(false);
  const { chatData, user } = useAuth();

  const tabs = [
    { key: "upcoming", label: "UPCOMING (1)" },
    { key: "past", label: "PAST (0)" },
  ];

  return (
    <div className="relative overflow-hidden">
      {/* HEADER & TABS */}
      <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
        <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
          <div className="mx-auto">
            <div className="flex items-center justify-center gap-1">
              <p className="ml-6 text-md font-medium text-gray-200">
                My Events
              </p>
              <CircularFlag countryCode={user?.country} />
            </div>
          </div>
          <p className="text-md font-medium text-gray-200">Help</p>
        </div>
      </div>

      <div className="flex w-full bg-blue-700 tabs-bar">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`tab-item px-4 py-4 text-xs text-center w-full font-medium relative ${
              activeTab === tab.key ? "text-gray-200" : "text-gray-300"
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            {activeTab === tab.key && (
              <div className="absolute bottom-0 left-0 right-0 h-1 underline bg-white shadow-md rounded-t-md" />
            )}
          </div>
        ))}
      </div>

      {/* EVENT CARD */}
      {chatData ? (
        <div className="px-2 mt-1">
          <div
            onClick={() => setShowDetails(true)}
            className="shadow-md w-full h-[13.3rem] bg-cover bg-center relative"
            style={{ backgroundImage: `url(${chatData?.image_url})` }}
          >
            {/* <div className="absolute inset-0 bg-black opacity-30"></div> */}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>

            <div className="absolute inset-0 z-10 flex flex-col justify-end px-2 pb-2">
              <h2 className="text-gray-200 text-lg leading-6">
                {chatData?.event_name}
              </h2>
              <div>
                <p className="text-xs text-gray-300 truncate">
                  {chatData?.event_date && chatData?.event_time
                    ? formatDateTime(chatData.event_date, chatData.event_time)
                    : "Date not available"}{" "}
                  • {chatData?.event_venue}
                </p>
              </div>
              <div className="flex items-center gap-1 mt-1">
                <IoTicket className="text-gray-300" />
                <p className="text-xs text-gray-300 ">
                  {chatData?.num_seats}{" "}
                  {chatData?.num_seats > 1 ? "tickets" : "ticket"}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        "no events created"
      )}

      {/* SLIDING DETAILS TAB */}
      {showDetails && (
        <EventDetails
          chatData={chatData}
          onClose={() => setShowDetails(false)}
        />
      )}
    </div>
  );
}
